import demo from '@/views/demo';
import index from '@/views/index';
import baoming from '@/views/baoming';
import success from '@/views/success';
import judges from '@/views/judges';
import judgesSuccess from '@/views/judgesSuccess';
import detail from '@/views/detail';
import prove from '@/views/prove';
import share from '@/views/share';
export default [
  {
    path: "/",
    name: "index",
    component: index,
    meta: { title: '新歌来啦官方通道' }
  },
  {
    path: "/index",
    name: "index1",
    component: index,
    meta: { title: '新歌来啦官方通道' }
  },
  {
    path: "/baoming",
    name: "baoming",
    component: baoming,
    meta: { title: '学员报名' }
  },
  {
    path: "/success",
    name: "success",
    component: success,
    meta: { title: '资料已递交' }
  },
  {
    path: "/judges",
    name: "judges",
    component: judges
  },
  {
    path: "/judgesSuccess",
    name: "judgesSuccess",
    component: judgesSuccess,
    meta: { title: '新歌来啦官方通道' }
  },
  {
    path: "/detail",
    name: "detail",
    component: detail
  },
  {
    path: "/prove",
    name: "prove",
    component: prove,
    meta: { title: '新歌来啦官方通道' }
  },
  {
    path: "/share",
    name: "share",
    component: share,
    meta: { title: '新歌来啦官方通道' }
  },
  {
    path: "/demo",
    name: "demo",
    component: demo,
    meta: { title: 'demo' }
  }
];
